import React from "react";

export default function QuantityTableOtherRelease({
  qtyAfterDelivery,
  currentStockAfterDelivery,
}) {
  const table = {
    header: [
      {
        id: 1,
        title: "출고 후 해당 LOT 재고수량",
      },
      {
        id: 2,
        title: "출고 후 현재 재고수량",
      },
    ],
  };
  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className={`p-2  border border-[#dddddd] ${
                    val?.id === 2
                      ? "bg-[#f2dca8] font-bold"
                      : "bg-[#f2f2f4]  font-normal"
                  }`}
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {qtyAfterDelivery}
              </td>
              <td className="p-3 border border-[#dddddd] font-bold">
                {currentStockAfterDelivery}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
